import { randomUUID } from '@core/utils/uuid';

/** Names this browser page, so it releases only the edit locks it took itself. */
export const pageClientId = randomUUID();
